import { connect } from 'react-redux';
import CreateRoom from './create-room';

export default connect((state) => ({
  currentStepNumber: state.RoomList.currentStep,
}))(CreateRoom);
